<mat-card class="survey-card-container">   
    <button id="survey-button-side-nav-outside" mat-icon-button (click)="sidenavStepper.toggle()" class="button-toggle-sidenav-outside" *ngIf="!sidenavStepper.opened"><mat-icon>menu</mat-icon></button>
    <mat-sidenav-container class="survey-sidenav-container">
        <mat-sidenav #sidenavStepper mode="side" class="survey-sidenav-menu">
            <button id="survey-button-side-nav" mat-icon-button (click)="sidenavStepper.toggle()" class="button-toggle-sidenav"><mat-icon>menu</mat-icon></button>
            <div id="survey-side-menu">
                <mat-nav-list>
                    <a id="survey-link-ohi" mat-list-item
                        (click)="OnClickStepForward(OtherHealthInsuranceComponent.StepIndex)"
                        class="menu-item"
                        [class.active-step]="OtherHealthInsuranceComponent?.ActiveStep">
                        <span matListItemTitle>Other Health Insurance</span>
                    </a>
                    <a id="survey-link-ssb" mat-list-item
                        (click)="OnClickStepForward(SocialSecurityBenefitsComponent.StepIndex)"
                        class="menu-item"
                        [class.active-step]="SocialSecurityBenefitsComponent?.ActiveStep"
                        [disabled]="!OtherHealthInsuranceFormIsValid">
                        <span matListItemTitle>Social Security Benefits</span>
                    </a>
                    <a id="survey-link-es" mat-list-item
                        (click)="OnClickStepForward(EmploymentStatusComponent.StepIndex)"
                        class="menu-item"
                        [class.active-step]="EmploymentStatusComponent?.ActiveStep"
                        [disabled]="!SocialSecurityBenefitsFormIsValid" >
                        <span matListItemTitle>Employment Status</span>
                    </a>
                    <a id="survey-link-ob" mat-list-item
                        (click)="OnClickStepForward(OtherBenefitsComponent.StepIndex)"
                        class="menu-item"
                        [class.active-step]="OtherBenefitsComponent?.ActiveStep"
                        [disabled]="!EmploymentStatusFormIsValid">
                        <span matListItemTitle>Other Benefits</span>
                    </a>
                    <a id="survey-link-summary" mat-list-item
                        (click)="OnClickStepForward(SummaryComponent?.StepIndex)"
                        class="menu-item"
                        [class.active-step]="SummaryComponent?.ActiveStep"
                        [disabled]="!OtherBenefitsFormIsValid">
                        <span matListItemTitle>Summary</span>
                    </a>
                </mat-nav-list>
            </div>
            <div class="footer-left">
                <a (click)="OnClickWhoWeAre()" class="footer-section">Who Are We?</a>
                <a (click)="OnClickContactUs()" class="footer-section">Contact Us</a>
                <a (click)="OnClickFaq()" class="footer-section">Frequently Asked Questions</a>
            </div>
        </mat-sidenav>
        <mat-sidenav-content class="survey-sidenav-content">
            <div class="inner-container">
                <ng-container>
                    <mat-vertical-stepper #stepperSurvey [animationDuration]="0">
                        <mat-step [stepControl]="OtherHealthInsuranceComponent?.Form">
                            <div class="survey-mat-stepper-content">
                                <div class="survey-step-header">
                                    <h3 class="survey-step-title">Section 1: {{OtherHealthInsuranceComponent?.Title}}</h3>
                                </div>
                                <div id="survey-ohi-body" class="survey-step-body">
                                    <div class="survey-step-content">
                                        <app-survey-other-health-insurance id="survey-ohi-componenet"></app-survey-other-health-insurance>
                                    </div>
                                </div>
                                <div id="survey-ohi-action" class="survey-step-footer">
                                    <div class="inline-button other-insurance-page">
                                        <button id="survey-ohi-button-next"
                                                mat-raised-button
                                                matStepperNext
                                                (click)="OnClickStepSubmit(OtherHealthInsuranceComponent.StepIndex)"
                                                *ngIf="OtherHealthInsuranceFormIsValid"
                                                class="mat-flat-button mat-primary next-button btn-md">
                                                <div class="next-button-content">
                                                    <mat-icon>arrow_forward_ios</mat-icon>
                                                    <div>
                                                        {{ IsNextButtonMobile ? 'Next' : 'Next: ' }}<br>
                                                        <b>{{ IsNextButtonMobile ? '' : 'Social Security Benefits' }}</b>
                                                    </div>
                                                </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </mat-step>
                        <mat-step [stepControl]="SocialSecurityBenefitsComponent?.Form">
                            <div class="survey-mat-stepper-content">
                                <div class="survey-step-header">
                                    <h3 class="survey-step-title">Section 2: {{SocialSecurityBenefitsComponent?.Title}}</h3>
                                </div>
                                <div  id="survey-ssb-body" class="survey-step-body">
                                    <div class="survey-step-content">
                                        <app-survey-social-security-benefits id="survey-ssb-componenet"></app-survey-social-security-benefits>
                                    </div>
                                </div>
                                <div  id="survey-ssb-action" class="survey-step-footer">
                                    <div class="inline-button">
                                        <button id="survey-ssb-button-back"
                                                mat-raised-button
                                                matStepperPrevious
                                                (click)="OnClickStepBackward(OtherHealthInsuranceComponent.StepIndex)"
                                                class="mat-flat-button mat-accent btn-sm">
                                                <mat-icon>arrow_backward_ios</mat-icon>
                                                Back
                                        </button>
                                        <button id="survey-ssb-button-next"
                                                mat-raised-button
                                                matStepperNext
                                                (click)="OnClickStepSubmit(SocialSecurityBenefitsComponent.StepIndex)"
                                                *ngIf="SocialSecurityBenefitsFormIsValid"
                                                class="mat-flat-button mat-primary next-button btn-md">
                                                <div class="next-button-content">
                                                    <mat-icon>arrow_forward_ios</mat-icon>
                                                    <div>
                                                        {{ IsNextButtonMobile ? 'Next' : 'Next: ' }}<br>
                                                        <b>{{ IsNextButtonMobile ? '' : 'Employment Status' }}</b>
                                                    </div>
                                                </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </mat-step>
                        <mat-step [stepControl]="EmploymentStatusComponent?.Form">
                            <div class="survey-mat-stepper-content">
                                <div class="survey-step-header">
                                    <h3 class="survey-step-title">Section 3: {{EmploymentStatusComponent?.Title}}</h3>
                                </div>
                                <div  id="survey-es-body" class="survey-step-body">
                                    <div class="survey-step-content">
                                        <app-survey-employment-status id="survey-es-componenet"></app-survey-employment-status>
                                    </div>
                                </div>
                                <div  id="survey-es-action" class="survey-step-footer">
                                    <div class="inline-button">
                                        <button id="survey-es-button-back"
                                                mat-raised-button
                                                matStepperPrevious
                                                (click)="OnClickStepBackward(SocialSecurityBenefitsComponent.StepIndex)"
                                                class="mat-flat-button mat-accent btn-sm">
                                                <mat-icon>arrow_backward_ios</mat-icon>
                                                Back
                                        </button>
                                        <button id="survey-es-button-next"
                                                mat-raised-button
                                                matStepperNext
                                                (click)="OnClickStepSubmit(EmploymentStatusComponent.StepIndex)"
                                                *ngIf="EmploymentStatusFormIsValid"
                                                class="mat-flat-button mat-primary next-button btn-md">
                                                <div class="next-button-content">
                                                    <mat-icon>arrow_forward_ios</mat-icon>
                                                    <div>
                                                        {{ IsNextButtonMobile ? 'Next' : 'Next: ' }}<br>
                                                        <b>{{ IsNextButtonMobile ? '' : 'Other Benefits' }}</b>
                                                    </div>
                                                </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </mat-step>
                        <mat-step [stepControl]="OtherBenefitsComponent?.Form">
                            <div class="survey-mat-stepper-content">
                                <div class="survey-step-header">
                                    <h3 class="survey-step-title">Section 4: {{OtherBenefitsComponent?.Title}}</h3>
                                </div>
                                <div  id="survey-ob-body" class="survey-step-body">
                                    <div class="survey-step-content">
                                        <app-survey-other-benefits id="survey-ob-componenet"></app-survey-other-benefits>
                                    </div>
                                </div>
                                <div id="survey-ob-action" class="survey-step-footer">
                                    <div class="inline-button">
                                        <button id="survey-ob-button-back"
                                                mat-raised-button
                                                matStepperPrevious
                                                (click)="OnClickStepBackward(EmploymentStatusComponent.StepIndex)"
                                                class="mat-flat-button mat-accent btn-sm">
                                                <mat-icon>arrow_backward_ios</mat-icon>
                                                Back
                                        </button>
                                        <button id="survey-ob-button-next"
                                                mat-raised-button
                                                matStepperNext
                                                (click)="OnClickStepSubmit(OtherBenefitsComponent.StepIndex)"
                                                *ngIf="OtherBenefitsFormIsValid"
                                                class="mat-flat-button mat-primary next-button btn-md">
                                                <div class="next-button-content">
                                                    <mat-icon>arrow_forward_ios</mat-icon>
                                                    <div>
                                                        {{ IsNextButtonMobile ? 'Next' : 'Next: ' }}<br>
                                                        <b>{{ IsNextButtonMobile ? '' : 'Summary' }}</b>
                                                    </div>
                                                </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </mat-step>
                        <mat-step [stepControl]="SummaryComponent?.Form">
                            <div class="survey-mat-stepper-content">
                                <div class="summary-survey-step-header">
                                    <h2 class="survey-step-title">{{SummaryComponent?.Title}}</h2>
                                </div>
                                <div  id="survey-summary-body" class="survey-step-body">
                                    <div class="survey-step-content">
                                        <app-summary id="survey-summary-componenet"></app-summary>
                                    </div>
                                </div>
                                <div  id="survey-summary-action" class="survey-step-footer">
                                    <div class="inline-button">
                                        <button id="survey-summary-button-back"
                                                mat-raised-button
                                                matStepperPrevious
                                                (click)="OnClickStepBackward(OtherBenefitsComponent.StepIndex)"
                                                class="mat-flat-button mat-accent btn-sm">
                                                <mat-icon>arrow_backward_ios</mat-icon>
                                                Back
                                        </button>
                                        <button id="survey-summary-button-next"
                                                mat-raised-button
                                                matStepperNext
                                                (click)="OnClickStepSubmit(SummaryComponent?.StepIndex)"
                                                *ngIf="SummaryFormIsValid"
                                                class="mat-flat-button mat-primary next-button">
                                                Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </mat-step>
                    </mat-vertical-stepper>
                </ng-container>
                <ng-container>
                    <app-footer id="dynamic-footer" [ShowHeader]="false"></app-footer>
                </ng-container>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</mat-card>
